export enum BadgeStyle {
    BORDER = "border",
    FLAT = "flat",
    FILLED = "filled",
}

export enum BadgeShape {
    BADGE = "badge",
    PILL = "pill",
    SQUARE = "square",
}
